export const assistantServiceOptions = [
  "Experience",
  "Miscellaneous Fee",
  "Drop Off & Pick Up",
  "Escort",
  "Security Personal",
  "Gate Pass",
];

// Temporary compatibility bridge until the backend accepts the new service labels.
const displayToBackendServiceMap = {
  Experience: "Transportation",
  "Miscellaneous Fee": "Personal Expense",
  "Drop Off & Pick Up": "Airport Pickups",
  Escort: "Escort",
  "Security Personal": "Porter",
  "Gate Pass": "Entrance Fee",
};

const backendToDisplayServiceMap = {
  Transportation: "Experience",
  Lunch: "Miscellaneous Fee",
  "Entrance Fee": "Gate Pass",
  "Airport Pickups": "Drop Off & Pick Up",
  Escort: "Escort",
  Souvenirs: "Miscellaneous Fee",
  "Personal Expense": "Miscellaneous Fee",
  Porter: "Security Personal",
  Lounge: "Experience",
};

export const normalizeAssistantServices = (value) => {
  if (!Array.isArray(value)) return [];

  return Array.from(
    new Set(
      value
        .map((service) => {
          if (assistantServiceOptions.includes(service)) return service;
          return backendToDisplayServiceMap[service] || null;
        })
        .filter(Boolean)
    )
  );
};

export const serializeAssistantServices = (value) => {
  if (!Array.isArray(value)) return [];

  return Array.from(
    new Set(
      value
        .map((service) => displayToBackendServiceMap[service] || service)
        .filter(Boolean)
    )
  );
};

export const deriveAssistantNotIncluded = (value) => {
  const selectedServices = normalizeAssistantServices(value);
  return assistantServiceOptions.filter(
    (service) => !selectedServices.includes(service)
  );
};
